module.exports = __webpack_public_path__ + "static/media/hdfc_ergo_ic_logo_summary.f0edc616.svg";